function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 3c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7c0-1.9-.7-3.6-2.1-4.9S8.9 3 7 3zm3.5 7.2l-5 3.4c-.1.1-.2.1-.3 0-.1 0-.1-.1-.1-.2V6.6c0-.1.1-.2.1-.2h.3l5 3.4c.1.1.1.1.1.2s0 .2-.1.2z"
});

function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 20"
  }, props), _ref);
}

export default SvgVideo;